export default __webpack_public_path__ + "static/media/crystal.ca490ac6.png";